import { gql } from '@apollo/client';

const GET_MACHINE_CONFIG = gql`
    query GetMachineConfig {
        getMachineConfig {
            temperature
            pending_config
            device_name
            active_config
        }
    }
`;

const UPDATE_MACHINE_CONFIG = gql`
    mutation Mutation($input: MachineConfigInput!) {
        updateMachineConfig(input: $input) {
            message
            success
            data
        }
    }
`;

const GET_STATIC_LISTINGS = gql`
    query Query($category: String) {
        getStaticListings(category: $category)
    }
`;

export { GET_MACHINE_CONFIG, UPDATE_MACHINE_CONFIG, GET_STATIC_LISTINGS };
